import { render, staticRenderFns } from "./RuleEngineRules.vue?vue&type=template&id=72d67fda&scoped=true&"
import script from "./RuleEngineRules.vue?vue&type=script&lang=js&"
export * from "./RuleEngineRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d67fda",
  null
  
)

export default component.exports